(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["interface-totem"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initTotem = (root) => {
      if (!root || root.dataset.totemReady === 'true') return;
      root.dataset.totemReady = 'true';
      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
      const materialName = root.querySelector('[data-material-name]');
      const activate = (tab, focus) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        root.dataset.form = tab.dataset.form || 'grease';
        if (materialName) materialName.textContent = tab.dataset.name || '';
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab, false));
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(tabs[next], true);
        });
      });
    };
    document.querySelectorAll('[data-interface-totem]').forEach(initTotem);
    document.addEventListener('shopify:section:load', (event) => initTotem(event.target.querySelector('[data-interface-totem]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-document-request"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-document-request]');
    if (!root) return;
    const params = new URLSearchParams(window.location.search);
    const documentType = root.querySelector('[data-document-request-type]');
    const model = root.querySelector('[data-document-request-model]');
    const requestedDocument = params.get('document');
    const requestedModel = params.get('model');

    if (documentType && requestedDocument) {
      const matchingOption = Array.from(documentType.options).find((option) => option.value === requestedDocument.toLowerCase());
      if (matchingOption) documentType.value = matchingOption.value;
    }

    if (model && requestedModel) model.value = requestedModel;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-inquiry-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-inquiry-form]').forEach((section) => {
    const contexts = new Map(
      Array.from(section.querySelectorAll('[data-inquiry-context-option]')).map((option) => [option.dataset.interest, option.dataset])
    );
    const queryInterest = new URLSearchParams(window.location.search).get('interest');
    const defaultInterest = section.dataset.inquiryContext;
    const interest = contexts.has(queryInterest) ? queryInterest : (contexts.has(defaultInterest) ? defaultInterest : 'general-business');
    const select = section.querySelector('[data-business-interest]');
    const application = section.querySelector('[data-inquiry-application]');
    const product = section.querySelector('[data-inquiry-product]');
    const source = section.querySelector('[data-inquiry-source]');
    const contextLabel = section.querySelector('[data-inquiry-context-label]');
    const applyContext = (nextInterest) => {
      const context = contexts.get(nextInterest) || contexts.get('general-business');
      const previousApplication = section.dataset.inquiryAutoApplication || '';
      section.dataset.inquiryContext = nextInterest;
      section.dataset.inquiryAutoApplication = context.application;
      section.querySelector('[data-inquiry-eyebrow]').textContent = context.eyebrow;
      section.querySelector('[data-inquiry-heading]').textContent = context.heading;
      section.querySelector('[data-inquiry-intro]').textContent = context.intro;
      if (select) {
        select.value = nextInterest;
        if (contextLabel) contextLabel.textContent = select.options[select.selectedIndex].text;
      }
      if (application && (application.value === '' || application.value === previousApplication)) application.value = context.application;
      if (source) source.value = context.source;
    };

    applyContext(interest);
    const queryProduct = new URLSearchParams(window.location.search).get('product');
    if (product && queryProduct && product.value === '') product.value = queryProduct;
    if (select) select.addEventListener('change', () => applyContext(select.value));
  });

  } catch(e) { console.error(e); }
})();
})();
